import styled from '@emotion/styled';
import { space } from 'styled-system';
import { StyledProps as Props, Theme } from './SectionTitle.types';
import Heading from '../../atoms/Heading/Heading';

export const Wrapper = styled.div<Props, Theme>`
  ${space}
`;

export const Header = styled(Heading)<Props, Theme>`
  margin: 0;

  ${space}
`;
